import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/header_logo1.png'
import _imports_1 from '@/assets/images/header_logo2.png'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: "LOGO"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  alt: "LOGO"
}
const _hoisted_3 = {
  key: 2,
  src: _imports_1,
  alt: "LOGO"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLabo)
    ? (_openBlock(), _createElementBlock("img", _hoisted_1))
    : (_ctx.isShindo)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3))
}